<template>
  <div id="event-handler" />
</template>

<script setup>
import { getCurrentInstance } from "vue";

// Access the global emitter from the Vue app instance
const { proxy } = getCurrentInstance();
const emitter = proxy?.emitter;

if (emitter) {
  emitter.on("firstInteraction", (data) =>
    postMessage("FormesterFirstInteraction", data),
  );

  emitter.on("pageChange", (data) => postMessage("FormesterPageChange", data));

  emitter.on("submit", (data) => postMessage("FormesterSubmit", data));
}

function postMessage(event, data) {
  window.parent.postMessage(
    {
      source: "formester",
      event: event,
      ...data,
    },
    "*",
  );
}
</script>
